module.exports = __webpack_public_path__ + "static/Number 105-c4de232e8ad374e21a2f96e6d2ed0008.jpg";